import Camera, { FACING_MODES, IMAGE_TYPES, IMAGE_DATA_TYPE } from './Camera'

export { Camera, FACING_MODES, IMAGE_TYPES, IMAGE_DATA_TYPE }

export default Camera
